import * as React from 'react';
import { useLocation, WindowLocation } from '@reach/router';
import loadBookingFlow from 'booking/lib/loadBookingFlow';
import { useDispatch } from 'react-redux';
import { PreselectBookingData } from '../../lib/types';
import { setBooted, setStepValidated } from '../../redux/actions';

export default function useBooking(): void {
    const location = useLocation() as WindowLocation<PreselectBookingData>;
    const dispatch = useDispatch();

    // read `booking_origin` from query string
    const params = new URLSearchParams(location.search);
    const bookingOrigin = params.get('booking_origin');

    React.useEffect(() => {
        const saveOrigin = async (origin: string) => {
            const { saveSessionStorage } = await import('lib/storage');
            saveSessionStorage<string>('booking_origin', origin);
        };
        if (bookingOrigin) {
            saveOrigin(bookingOrigin).then();
        }
    }, [bookingOrigin]);

    React.useEffect(() => {
        loadBookingFlow().then(({ selectDate, selectLocation, selectTime }) => {
            const locationId = location.state?.locationId;
            const date = location.state?.date;
            const time = location.state?.time;

            if (locationId) {
                dispatch(setStepValidated('city', true));
                dispatch(setStepValidated('location', true));
                dispatch(selectLocation(locationId));
            }

            if (date) {
                dispatch(selectDate(date));

                if (time) {
                    dispatch(setStepValidated('date', true));
                    dispatch(selectTime(time));
                }
            }

            setTimeout(() => {
                dispatch(setBooted(true));
            }, 100);
        });
    }, [dispatch, location.state]);
}
